import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createTextVNode as _createTextVNode, normalizeStyle as _normalizeStyle, vModelText as _vModelText, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, renderList as _renderList, vModelRadio as _vModelRadio, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = { class: "card mb-25 border-0 rounded-0 bg-white letter-spacing" }
const _hoisted_2 = { class: "card-head box-shadow bg-white d-lg-flex align-items-center justify-content-between p-15 p-sm-20 p-md-25" }
const _hoisted_3 = { class: "row" }
const _hoisted_4 = { class: "col-12" }
const _hoisted_5 = { class: "form-group mb-3" }
const _hoisted_6 = { class: "my-suggestion-item" }
const _hoisted_7 = { class: "card-body p-15 p-sm-20 p-md-25" }
const _hoisted_8 = { class: "col-md-6 form-group mb-3" }
const _hoisted_9 = { class: "col-md-6 form-group mb-3" }
const _hoisted_10 = { class: "col-md-6 form-group mb-3" }
const _hoisted_11 = { key: 0 }
const _hoisted_12 = {
  key: 0,
  class: "text-danger"
}
const _hoisted_13 = {
  key: 1,
  class: "text-danger"
}
const _hoisted_14 = { class: "col-12 form-group mb-3" }
const _hoisted_15 = { class: "col-md-4 form-group mb-3" }
const _hoisted_16 = {
  key: 0,
  class: "text-danger"
}
const _hoisted_17 = { class: "col-md-4 form-group mb-3" }
const _hoisted_18 = { class: "col-md-4 form-group mb-3" }
const _hoisted_19 = {
  key: 0,
  class: "text-danger"
}
const _hoisted_20 = {
  key: 1,
  class: "text-success"
}
const _hoisted_21 = { class: "col-12 form-group mb-3" }
const _hoisted_22 = { class: "col-12 col-md-6 form-group mb-3" }
const _hoisted_23 = { class: "col-12 col-md-6 form-group mb-3" }
const _hoisted_24 = { class: "col-12 form-group mb-3" }
const _hoisted_25 = { class: "col-12" }
const _hoisted_26 = { class: "form-group mb-3" }
const _hoisted_27 = ["placeholder"]
const _hoisted_28 = { class: "form-group mb-3" }
const _hoisted_29 = ["placeholder"]
const _hoisted_30 = { class: "form-group mb-3" }
const _hoisted_31 = ["placeholder"]
const _hoisted_32 = { class: "col-12 form-group mb-3" }
const _hoisted_33 = { class: "col-12 form-group mb-3" }
const _hoisted_34 = ["id", "value"]
const _hoisted_35 = ["for"]
const _hoisted_36 = { class: "col-md-12 d-flex align-items-center justify-content-between mt-20" }
const _hoisted_37 = ["disabled"]
const _hoisted_38 = {
  key: 0,
  class: "spinner-border spinner-border-sm ms-2"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_AutocompleteVue = _resolveComponent("AutocompleteVue")!
  const _component_v_select = _resolveComponent("v-select")!
  const _component_b_form_radio = _resolveComponent("b-form-radio")!
  const _component_b_row = _resolveComponent("b-row")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _cache[21] || (_cache[21] = _createElementVNode("label", { class: "form-label fw-medium text-black" }, "Chercher Colis", -1)),
            _createVNode(_component_AutocompleteVue, {
              search: _ctx.search,
              "get-result-value": (result) => result.code,
              placeholder: "Chercher Colis",
              onSubmit: _ctx.handleSelect,
              onOptionSelected: _ctx.handleSelect
            }, {
              result: _withCtx(({ result }) => [
                _createElementVNode("span", _hoisted_6, _toDisplayString(result.code), 1)
              ]),
              _: 1
            }, 8, ["search", "get-result-value", "onSubmit", "onOptionSelected"])
          ])
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_7, [
      _createElementVNode("form", {
        class: "row g-3",
        onSubmit: _cache[20] || (_cache[20] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.handleSubmit && _ctx.handleSubmit(...args)), ["prevent"]))
      }, [
        _createElementVNode("div", _hoisted_8, [
          _cache[22] || (_cache[22] = _createElementVNode("label", {
            class: "form-label fw-medium text-black",
            for: "colis"
          }, "Colis", -1)),
          _createVNode(_component_v_select, {
            class: "custom-select-height",
            id: "colis",
            label: "text",
            modelValue: _ctx.OpenColi,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.OpenColi) = $event)),
            options: _ctx.ColisList
          }, null, 8, ["modelValue", "options"])
        ]),
        _createElementVNode("div", _hoisted_9, [
          _createVNode(_component_b_form_radio, {
            modelValue: _ctx.ReplaceColis,
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.ReplaceColis) = $event)),
            value: 0,
            class: "custom-control-success",
            size: "md"
          }, {
            default: _withCtx(() => _cache[23] || (_cache[23] = [
              _createTextVNode(" Colis Simple ", -1)
            ])),
            _: 1,
            __: [23]
          }, 8, ["modelValue"])
        ]),
        _createElementVNode("div", _hoisted_10, [
          _createVNode(_component_b_form_radio, {
            modelValue: _ctx.ReplaceColis,
            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.ReplaceColis) = $event)),
            value: 1,
            class: "custom-control-success",
            size: "md"
          }, {
            default: _withCtx(() => [
              _cache[25] || (_cache[25] = _createTextVNode(" Colis Change ", -1)),
              _createElementVNode("span", {
                style: _normalizeStyle([_ctx.ReplaceColis == 1 ? { 'font-size': '12px' } : ''])
              }, _cache[24] || (_cache[24] = [
                _createElementVNode("br", null, null, -1),
                _createTextVNode(" Le colis sera remplacé avec le colis : ", -1)
              ]), 4)
            ]),
            _: 1,
            __: [25]
          }, 8, ["modelValue"]),
          (_ctx.ReplaceColis == 1)
            ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
                _withDirectives(_createElementVNode("input", {
                  class: "form-control",
                  placeholder: "Code de suivi",
                  "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.form.code_replace) = $event)),
                  onChange: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.searchColis && _ctx.searchColis(...args)))
                }, null, 544), [
                  [_vModelText, _ctx.form.code_replace]
                ]),
                (_ctx.existcolis)
                  ? (_openBlock(), _createElementBlock("small", _hoisted_12, "Ce colis n'existe pas"))
                  : _createCommentVNode("", true),
                (_ctx.replacecolis)
                  ? (_openBlock(), _createElementBlock("small", _hoisted_13, "Vous ne pouvez pas remplacer ce colis"))
                  : _createCommentVNode("", true)
              ]))
            : _createCommentVNode("", true)
        ]),
        _cache[41] || (_cache[41] = _createElementVNode("div", { class: "col-12" }, [
          _createElementVNode("hr")
        ], -1)),
        _createElementVNode("div", _hoisted_14, [
          _cache[26] || (_cache[26] = _createElementVNode("label", {
            class: "form-label fw-medium text-black",
            for: "customer"
          }, "Client", -1)),
          _createVNode(_component_v_select, {
            class: "custom-select-height",
            required: "",
            id: "customer",
            label: "name",
            modelValue: _ctx.customer,
            "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.customer) = $event)),
            placeholder: "Client",
            options: _ctx.customerList
          }, null, 8, ["modelValue", "options"])
        ]),
        _createElementVNode("div", _hoisted_15, [
          _cache[27] || (_cache[27] = _createElementVNode("label", {
            class: "form-label fw-medium text-black",
            for: "code"
          }, "Code de suivi", -1)),
          _withDirectives(_createElementVNode("input", {
            id: "code",
            "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.form.code) = $event)),
            onChange: _cache[7] || (_cache[7] = 
//@ts-ignore
(...args) => (_ctx.verifiedCode && _ctx.verifiedCode(...args))),
            placeholder: "Code de suivi",
            class: "form-control"
          }, null, 544), [
            [_vModelText, _ctx.form.code]
          ]),
          (_ctx.codeerror)
            ? (_openBlock(), _createElementBlock("small", _hoisted_16, "Ce code existe déjà"))
            : _createCommentVNode("", true)
        ]),
        _createElementVNode("div", _hoisted_17, [
          _cache[28] || (_cache[28] = _createElementVNode("label", {
            class: "form-label fw-medium text-black",
            for: "dest"
          }, "Destinataire", -1)),
          _withDirectives(_createElementVNode("input", {
            id: "dest",
            "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.form.receiver) = $event)),
            placeholder: "Destinataire",
            class: "form-control"
          }, null, 512), [
            [_vModelText, _ctx.form.receiver]
          ])
        ]),
        _createElementVNode("div", _hoisted_18, [
          _cache[29] || (_cache[29] = _createElementVNode("label", {
            class: "form-label fw-medium text-black",
            for: "phone"
          }, "Numéro de téléphone *", -1)),
          _withDirectives(_createElementVNode("input", {
            id: "phone",
            "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.form.phone) = $event)),
            type: "text",
            inputmode: "numeric",
            pattern: "[0-9]*",
            onChange: _cache[10] || (_cache[10] = ($event: any) => (_ctx.blackList(_ctx.form.phone))),
            placeholder: "Numéro de téléphone *",
            class: "form-control"
          }, null, 544), [
            [_vModelText, _ctx.form.phone]
          ]),
          (_ctx.error_blacklst.msg)
            ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                (_ctx.error_blacklst.msg == 'exist')
                  ? (_openBlock(), _createElementBlock("small", _hoisted_19, " Ce numéro est dans la black liste ( " + _toDisplayString(_ctx.error_blacklst.count) + " fois) ", 1))
                  : _createCommentVNode("", true),
                (_ctx.error_blacklst.msg == 'not exist')
                  ? (_openBlock(), _createElementBlock("small", _hoisted_20, "Ce numéro est sûr"))
                  : _createCommentVNode("", true)
              ], 64))
            : _createCommentVNode("", true)
        ]),
        _createElementVNode("div", _hoisted_21, [
          _cache[30] || (_cache[30] = _createElementVNode("label", {
            class: "form-label fw-medium text-black",
            for: "city"
          }, "Ville", -1)),
          _createVNode(_component_v_select, {
            class: "custom-select-height",
            id: "city",
            required: "",
            label: "name",
            modelValue: _ctx.city,
            "onUpdate:modelValue": [
              _cache[11] || (_cache[11] = ($event: any) => ((_ctx.city) = $event)),
              _ctx.onCityChange
            ],
            options: _ctx.citiesList,
            placeholder: "Ville"
          }, null, 8, ["modelValue", "options", "onUpdate:modelValue"])
        ]),
        _createElementVNode("div", _hoisted_22, [
          _cache[31] || (_cache[31] = _createElementVNode("label", {
            class: "form-label fw-medium text-black",
            for: "adresse"
          }, "Adresse", -1)),
          _withDirectives(_createElementVNode("textarea", {
            id: "adresse",
            rows: "2",
            maxlength: "90",
            "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.form.address) = $event)),
            placeholder: "Adresse",
            class: "form-control"
          }, null, 512), [
            [_vModelText, _ctx.form.address]
          ])
        ]),
        _createElementVNode("div", _hoisted_23, [
          _cache[32] || (_cache[32] = _createElementVNode("label", {
            class: "form-label fw-medium text-black",
            for: "comment"
          }, "Commentaire", -1)),
          _withDirectives(_createElementVNode("textarea", {
            id: "comment",
            "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((_ctx.form.note) = $event)),
            rows: "2",
            maxlength: "55",
            placeholder: "Commentaire",
            class: "form-control"
          }, null, 512), [
            [_vModelText, _ctx.form.note]
          ])
        ]),
        _createElementVNode("div", _hoisted_24, [
          _cache[33] || (_cache[33] = _createElementVNode("label", {
            class: "form-label fw-medium text-black",
            for: "price"
          }, "Prix", -1)),
          _withDirectives(_createElementVNode("input", {
            id: "price",
            "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((_ctx.form.price) = $event)),
            type: "number",
            min: "1",
            placeholder: "Prix",
            class: "form-control"
          }, null, 512), [
            [_vModelText, _ctx.form.price]
          ])
        ]),
        _createElementVNode("div", _hoisted_25, [
          _createElementVNode("div", _hoisted_26, [
            _cache[34] || (_cache[34] = _createElementVNode("label", { class: "form-label fw-medium text-black" }, "Frais de livraison", -1)),
            _withDirectives(_createElementVNode("input", {
              id: "fees_livred",
              "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => ((_ctx.fees_livred) = $event)),
              placeholder: _ctx.fl + ' ' + _ctx.$devis + ' (frais calculés)',
              class: "form-control"
            }, null, 8, _hoisted_27), [
              [_vModelText, _ctx.fees_livred]
            ])
          ]),
          _createElementVNode("div", _hoisted_28, [
            _cache[35] || (_cache[35] = _createElementVNode("label", { class: "form-label fw-medium text-black" }, "Frais de retour", -1)),
            _withDirectives(_createElementVNode("input", {
              id: "fees_returned",
              "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => ((_ctx.fees_returned) = $event)),
              placeholder: _ctx.fr + ' ' + _ctx.$devis + ' (frais calculés)',
              class: "form-control"
            }, null, 8, _hoisted_29), [
              [_vModelText, _ctx.fees_returned]
            ])
          ]),
          _createElementVNode("div", _hoisted_30, [
            _cache[36] || (_cache[36] = _createElementVNode("label", { class: "form-label fw-medium text-black" }, "Frais de refusé", -1)),
            _withDirectives(_createElementVNode("input", {
              id: "fees_refused",
              "onUpdate:modelValue": _cache[17] || (_cache[17] = ($event: any) => ((_ctx.fees_refused) = $event)),
              placeholder: _ctx.frf + ' ' + _ctx.$devis + ' (frais calculés)',
              class: "form-control"
            }, null, 8, _hoisted_31), [
              [_vModelText, _ctx.fees_refused]
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_32, [
          _cache[37] || (_cache[37] = _createElementVNode("label", {
            class: "form-label fw-medium text-black",
            for: "agency"
          }, "Agence", -1)),
          _createVNode(_component_v_select, {
            class: "custom-select-height",
            id: "agency",
            label: "name",
            modelValue: _ctx.agency,
            "onUpdate:modelValue": _cache[18] || (_cache[18] = ($event: any) => ((_ctx.agency) = $event)),
            options: _ctx.agencyList,
            placeholder: "Agence",
            required: ""
          }, null, 8, ["modelValue", "options"])
        ]),
        _createElementVNode("div", _hoisted_33, [
          _cache[38] || (_cache[38] = _createElementVNode("label", { class: "form-label fw-medium text-black" }, "Statut", -1)),
          _createVNode(_component_b_row, null, {
            default: _withCtx(() => [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.statutList, (item, index) => {
                return (_openBlock(), _createElementBlock("div", {
                  class: "col-md-6",
                  key: index
                }, [
                  _withDirectives(_createElementVNode("input", {
                    required: "",
                    type: "radio",
                    class: "radio-btn",
                    id: item.id,
                    "onUpdate:modelValue": _cache[19] || (_cache[19] = ($event: any) => ((_ctx.statut) = $event)),
                    value: item
                  }, null, 8, _hoisted_34), [
                    [_vModelRadio, _ctx.statut]
                  ]),
                  _createElementVNode("label", {
                    class: "form-label fw-medium text-black",
                    for: item.id
                  }, _toDisplayString(item.name), 9, _hoisted_35)
                ]))
              }), 128))
            ]),
            _: 1
          })
        ]),
        _createElementVNode("div", _hoisted_36, [
          (_ctx.auth.can('PARCELS') && _ctx.auth.can('ADD_PARCEL'))
            ? (_openBlock(), _createElementBlock("button", {
                key: 0,
                type: "submit",
                class: "btn btn-success px-4 py-2",
                disabled: _ctx.codeerror == true
              }, [
                _cache[39] || (_cache[39] = _createTextVNode(" Enregistrer ", -1)),
                (_ctx.loading)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_38))
                  : _createCommentVNode("", true)
              ], 8, _hoisted_37))
            : _createCommentVNode("", true),
          _cache[40] || (_cache[40] = _createElementVNode("button", {
            type: "button",
            class: "btn btn-link text-danger"
          }, " Annuler ", -1))
        ])
      ], 32)
    ])
  ]))
}